/**
 * 对局历史快照（localStorage）。旧版无上限地追加会撑爆存储，这里强制只留最后 `MAX_HISTORY` 条。
 * 纯逻辑，不依赖 React / DOM：存储能力统一走 `platform/storage`。
 */

import type { FogChessState } from '@games/fog-chess'
import { storage, STORAGE_KEYS } from '../platform'

export const MAX_HISTORY = 50

interface HistorySnapshot {
  readonly board: FogChessState['board']
  readonly turn: FogChessState['turn']
  readonly moveCount: number
}

const toSnapshot = (state: FogChessState): HistorySnapshot => ({
  board: state.board,
  turn: state.turn,
  moveCount: state.moveCount,
})

/** 读取历史快照；内容不是数组或 JSON 损坏时一律视为空历史。 */
export function loadHistory(): readonly unknown[] {
  try {
    const raw = storage.get(STORAGE_KEYS.boardHistory)
    if (!raw) return []
    const parsed: unknown = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

/** 追加一条快照并裁剪到上限；存储不可用时静默忽略，绝不能影响对局。 */
export function pushHistory(state: FogChessState): void {
  try {
    const next = [...loadHistory(), toSnapshot(state)]
    storage.set(STORAGE_KEYS.boardHistory, JSON.stringify(next.slice(-MAX_HISTORY)))
  } catch {
    // 配额用尽 / 序列化失败都只是丢历史，不是对局错误
  }
}

export function clearHistory(): void {
  try {
    storage.remove(STORAGE_KEYS.boardHistory)
  } catch {
    // 清理失败同样不影响对局
  }
}
